import React from 'react'

const AdminProcessButton = ({ cell, row }) => {
    return (
        <div className={`${cell == "DONE" ? (row?.type == "transcoding_video" || row?.type == "m3u8_url" || row?.type == "brightcove") ? "green-color" : "yellow-color" : "yellow-color"}`}>
            <svg width="100" height="30" viewBox="0 0 200 50" xmlns="http://www.w3.org/2000/svg" >
                <rect x="0" y="0" width="200" height="50" rx="25" ry="25" fill="currentColor" stroke="#ffd9d9" stroke-width="1" />
                <rect x="0" y="0" width={`${cell === "PROCESS" ? Math.round(row?.transcoding_percentage || 0) : Math.round(row?.processed_low)}%`} height="50" rx="20" ry="20" fill="currentColor"
                    style={{
                        transition: cell == "PROCESS" && "width 0.6s ease-in-out",
                    }} >
                    {cell == "PROCESS" && <>
                        <animate
                            attributeName="width"
                            from="0"
                            to={`${Math.round(row?.transcoding_percentage || row?.processed_low)}%`}
                            dur="1s"
                            fill="freeze"
                            begin="0s"
                            repeatCount="ease"
                        />
                        <animate
                            attributeName="fill"
                            values="#ffea008a;#FFAB1B;#FFAB1B;#ffea008a"
                            dur="1s"
                            repeatCount="indefinite"
                        /></>}
                </rect>
                <text x="100" y="25" fontFamily="Poppins" fontSize="21" fontWeight="bold" fill={cell == "DONE" && (row?.type == "transcoding_video" || row?.type == "m3u8_url" || row?.type == "brightcove") ? "green" : "#ffc700"} textAnchor="middle" alignmentBaseline="middle">
                    {cell == "DONE" ? (row?.type != "transcoding_video" && row?.type != "m3u8_url" && row?.type != "brightcove") ? "NIL" : cell : (cell == "DRAFT" ? "PROGRESS" : cell)}  {(row?.draft == "0" && cell != "FAILED" && cell != "PROCESS") && `-  ${Math.round(row?.transcoding_percentage || row?.processed_low || 0)}%`}
                </text>
            </svg>
        </div>
    )
}

export default AdminProcessButton